<div class="task-indicator-container" *ngIf="(tasks$ | async) as tasks">
    <div class="task-card" *ngIf="tasks.length > 0" [@slideUp]>

        <!-- Header -->
        <div class="task-card-header" (click)="toggleCollapse()">
            <div class="header-left">
                <mat-icon class="header-icon">cloud_download</mat-icon>
                <span class="header-title">Background Tasks</span>
                <span class="task-badge" *ngIf="(activeCount$ | async) as count">
                    {{ count }}
                </span>
            </div>
            <button mat-icon-button class="collapse-btn"
                    (click)="$event.stopPropagation(); toggleCollapse()">
                <mat-icon>{{ isCollapsed ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
        </div>

        <!-- Task list (collapsible) -->
        <div class="task-list-wrapper"
             [@collapseExpand]="isCollapsed ? 'collapsed' : 'expanded'">
            <div class="task-list">
                <div class="task-item"
                     *ngFor="let task of tasks; trackBy: trackByTaskId">

                    <!-- Task label and actions -->
                    <div class="task-meta">
                        <div class="task-label-group">
                            <span class="task-title">{{ task.title }}</span>
                            <span class="task-subtitle">{{ task.subtitle }}</span>
                        </div>
                        <div class="task-actions">
                            <button mat-icon-button
                                    *ngIf="task.status === 'running' || task.status === 'pending'"
                                    (click)="cancel(task)"
                                    matTooltip="Cancel"
                                    class="action-btn">
                                <mat-icon>close</mat-icon>
                            </button>
                            <button mat-icon-button
                                    *ngIf="task.status === 'done' || task.status === 'error'"
                                    (click)="dismiss(task.id)"
                                    matTooltip="Dismiss"
                                    class="action-btn">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>

                    <!-- Progress bar -->
                    <mat-progress-bar
                        *ngIf="task.status === 'running'"
                        mode="determinate"
                        [value]="getProgressPercent(task)"
                        color="primary">
                    </mat-progress-bar>

                    <mat-progress-bar
                        *ngIf="task.status === 'pending'"
                        mode="indeterminate"
                        color="primary">
                    </mat-progress-bar>

                    <!-- Status text -->
                    <div class="task-status">
                        <span *ngIf="task.status === 'running'" class="status-running">
                            Processing...
                        </span>
                        <span *ngIf="task.status === 'pending'" class="status-running">
                            Starting...
                        </span>
                        <span *ngIf="task.status === 'done'" class="status-done">
                            Completed
                        </span>
                        <span *ngIf="task.status === 'error'" class="status-error">
                            {{ task.errorMessage }}
                        </span>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>